export const isLeftMBClick = (event: React.MouseEvent<Element>): boolean => event.button === 0;

export const isRightMBClick = (event: React.MouseEvent<Element>): boolean => event.button === 2;
